"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonParameterUnits = void 0;
exports.CommonParameterUnits = {
    voltage: {
        short: 'V',
        long: 'Volts',
        alternateNames: ['volts', 'volt'],
        usesSIPrefixes: true,
    },
    current: {
        short: 'A',
        long: 'Amps',
        alternateNames: ['amps', 'amp'],
        usesSIPrefixes: true,
    },
    power: {
        short: 'W',
        long: 'Watts',
        alternateNames: ['watts', 'watt'],
        usesSIPrefixes: true,
    },
    resistance: {
        short: 'Ω',
        long: 'Ohms',
        alternateNames: ['ohms', 'ohm', 'r', 'o'],
        usesSIPrefixes: true,
    },
    capacitance: {
        short: 'F',
        long: 'Farads',
        alternateNames: ['farads', 'farad'],
        usesSIPrefixes: true,
    },
    inductance: {
        short: 'H',
        long: 'Henries',
        alternateNames: ['henries', 'henry'],
        usesSIPrefixes: true,
    },
    frequency: {
        short: 'Hz',
        long: 'Hertz',
        alternateNames: ['hertz'],
        usesSIPrefixes: true,
    },
    time: {
        short: 's',
        long: 'Seconds',
        alternateNames: ['seconds', 'second'],
        usesSIPrefixes: true,
    },
    temperature: {
        short: 'C',
        long: 'Celsius',
        alternateNames: ['celsius', 'c'],
    },
    temperatureKelvin: {
        short: 'K',
        long: 'Kelvin',
        alternateNames: ['kelvin', 'k'],
    },
    gain: {
        short: 'dB',
        long: 'Decibels',
        alternateNames: ['decibels', 'db'],
    },
    percentage: {
        short: '%',
        long: 'Percentage',
        alternateNames: ['percent', 'percentage'],
    },
    unitless: {
        short: '',
        long: '',
        usesSIPrefixes: true,
    },
};
//# sourceMappingURL=CommonParameterUnits.js.map